import React, { memo, useState, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import avatar from "../../../common/icons/avatar1.png"; // import clsx from 'clsx';

import i18next from "i18next";
import { IconButton, Icon, Menu, MenuItem } from "@material-ui/core";
import { renderTime } from "../../../utils";
import { EaseChatContext } from "../index";
var useStyles = makeStyles(function (theme) {
  return {
    pulldownListItem: {
      padding: "10px 0",
      listStyle: "none",
      marginBottom: "26px",
      position: "relative",
      display: "flex",
      flexDirection: function flexDirection(props) {
        return props.bySelf ? "row-reverse" : "row";
      },
      alignItems: "center"
    },
    fileCard: {
      width: "252px",
      height: "72px",
      backgroundColor: "#fff",
      display: "flex",
      alignItems: "center",
      marginLeft: "10px",
      marginBottom: "26px"
    },
    fileIcon: {
      width: "59px",
      height: "59px",
      background: "rgba(35, 195, 129, 0.06)",
      borderRadius: "4px",
      border: "1px solid rgba(35, 195, 129, 0.06)",
      textAlign: "center",
      lineHeight: "59px",
      margin: "0 7px 0 7px",
      flexShrink: 0
    },
    fileInfo: {
      "& p": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: "126px",
        margin: "0"
      },
      "& span": {
        fontSize: "12px",
        color: "#010101",
        lineHeight: "16px"
      }
    },
    icon: {
      color: "rgba(35, 195, 129, 1)",
      fontWeight: "bold",
      fontSize: "38px"
    },
    download: {
      fontSize: "16px",
      color: "rgba(0,0,0,.6)",
      fontWeight: "bold",
      cursor: "pointer"
    },
    time: {
      position: "absolute",
      fontSize: "11px",
      height: "16px",
      color: "rgba(1, 1, 1, .2)",
      lineHeight: "16px",
      textAlign: "center",
      top: "-18px",
      width: "100%"
    },
    avatarStyle: {
      height: "40px",
      width: "40px",
      borderRadius: "50%"
    }
  };
});
var initialState = {
  mouseX: null,
  mouseY: null
};

function FileMessage(_ref) {
  var message = _ref.message,
      onRecallMessage = _ref.onRecallMessage,
      showByselfAvatar = _ref.showByselfAvatar;
  var easeChatProps = useContext(EaseChatContext);
  var onAvatarChange = easeChatProps.onAvatarChange;
  var classes = useStyles({
    bySelf: message.bySelf
  });

  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var handleClose = function handleClose() {
    setState(initialState);
  };

  var recallMessage = function recallMessage() {
    onRecallMessage(message);
    handleClose();
  };

  var handleClick = function handleClick(event) {
    event.preventDefault();
    setState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
  };

  return /*#__PURE__*/React.createElement("li", {
    className: classes.pulldownListItem
  }, !message.bySelf && /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: avatar,
    onClick: function onClick() {
      return onAvatarChange && onAvatarChange(message);
    }
  }), showByselfAvatar && message.bySelf && /*#__PURE__*/React.createElement("img", {
    className: classes.avatarStyle,
    src: avatar
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.fileCard,
    onContextMenu: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fileIcon
  }, i18next.t("file")), /*#__PURE__*/React.createElement("div", {
    className: classes.fileInfo
  }, /*#__PURE__*/React.createElement("p", null, message.filename), /*#__PURE__*/React.createElement("span", null, Math.floor(message.body.size / 1024) + "kb")), /*#__PURE__*/React.createElement("div", {
    className: classes.download
  }, /*#__PURE__*/React.createElement("a", {
    href: message.body.url,
    download: message.filename
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: "iconfont icon-xiazai"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, renderTime(message.time)), message.bySelf ? /*#__PURE__*/React.createElement(Menu, {
    keepMounted: true,
    open: state.mouseY !== null,
    onClose: handleClose,
    anchorReference: "anchorPosition",
    anchorPosition: state.mouseY !== null && state.mouseX !== null ? {
      top: state.mouseY,
      left: state.mouseX
    } : undefined
  }, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: recallMessage
  }, i18next.t("withdraw"))) : null);
}

export default memo(FileMessage);